export default [
  // PLATINUM
  // {
  //   link: 'http://www.raycullen.com/',             
  //   src: 'platinum/raycullen.jpg',
  //   type: 'platinum',
  // },
  // {
  //   link: 'http://www.italianhousepizza.com/',
  //   src: 'platinum/Italian House.jpg',
  //   type: 'platinum',
  // },
  {
    link: 'https://www.canada.ca/en/canadian-heritage.html',
    src: 'platinum/herritage.png',
    type: 'platinum', 
  },
  {
    link: 'http://www.london.ca/Pages/default.aspx',
    src: 'platinum/CITYcmyk.jpg',
    type: 'platinum', 
  },
  {
    link: 'http://www.profilecanada.com/companydetail.cfm?company=2426709_Community_Council-white_Oaks_London_ON',
    src: 'platinum/CCWO.jpg',
    type: 'platinum', 
  },
  {
    link: 'https://selectpath.ca/',
    src: 'gold/select-path.jpg',
    type: 'platinum'
  },
  {
    link: 'http://www.whiteoaksmall.ca/',
    src: 'platinum/wom.png',
    type: 'platinum', 
  },
  {
    link: 'https://mrsinghspizza.ca/',
    src: 'new/mr-singhs-pizza.png',
    type: 'platinum'
  },
  {
    link: 'https://www.facebook.com/London.Qatayef/',
    src: 'new/Just Fresh.jpeg',
    type: 'platinum'
  },
  {
    link: 'http://www.slnrc.org/families_first.htm',
    src: 'platinum/capc.png',
    type: 'platinum', 
  },
  {
    link: 'http://www.slnrc.org/',
    src: 'platinum/SLNRC logo.jpg',
    type: 'platinum', 
  },
  {
    link: 'https://www.yorkproperty.ca/',                        
    src: 'platinum/logo_york_home.png',
    type: 'platinum'
  },
  // {
  //   link: 'https://www.cvtaxservices.com/',         
  //   src: 'platinum/cv.svg',
  //   type: 'platinum', 
  // },

  // GOLD
  {
    link: 'https://www.metro.ca/en',
    src: 'gold/FB1211 metro logo cmyk.jpg',
    type: 'gold',
    wide: true,
  },
  {
    link: 'https://www.churchintheoaks.com',
    src: 'gold/church-in-the-oaks.svg',
    type: 'gold',
  },
  {
    link: 'https://www.libro.ca/',                           
    src: 'silver/libro.svg',
    type: 'gold',
  },
    {
    link: 'https://www.auburndev.com/',                           
    src: 'new/auburn-group.png',
    type: 'gold',
  },
  {
    link: 'https://www.drewloholdings.com/',
    src: 'gold/Drewlo.png',
    type: 'gold'
  },
  {
    link: 'https://www.nofrills.ca/store-locator/details/3728',
    src: 'silver/no-frills.png',
    type: 'gold',
  },
  {
    link: 'https://www.foodbasics.ca/index.en.html',
    src: 'gold/food-basics.svg',
    type: 'gold',
  },
  {
    link: 'https://london.ca/government/council-civic-administration/city-council/councillor-elizabeth-peloza',
    src: 'silver/elizabeth-peloza.png',
    type: 'gold'
  },
  {
    link: 'https://www.accessstorage.ca/en/',
    src: 'silver/Access Storage Logo.png',
    type: 'gold',
  },
  {
    link: 'http://chrisewer.ca/',
    src: 'gold/chris-ewer.png', 
    type: 'gold',
  },
  {
    link: 'https://www.pashop.com/',
    src: 'gold/pa-shop.png',
    type: 'gold',
    wide: true,
  },
  // {
  //   link: 'https://www.tshirttime.com/stores/white-oaks-mall/',
  //   src: 'gold/tshirttime.png',
  //   type: 'platinum',
  // },

  // SILVER
  {
    link: 'http://www.sutherlandelliott.ca/',                
    src: 'new/sutherland-elliot.jpg',
    type: 'silver',
  },
  {
    link: 'https://excaliburinsurance.ca/',                        
    src: 'new/excalibur.jpg',
    type: 'silver'
  },
  {
    link: 'https://london.ca/mayor',                        
    src: 'silver/Mayor Josh Morgan Graphic.png',
    type: 'silver'
  },
  {
    link: 'https://chop.ca/locations/london',                        
    src: 'new/chop-logo.png',
    type: 'silver'
  }
];